/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Tooltip, message, Checkbox, Typography, Button, Collapse, Modal, Dropdown, Menu } from "antd";
import React, { useEffect, useState } from "react";
import StatusLabel from "./Status";
import moment from "moment";
import { BiImageAdd } from "react-icons/bi";
import styles from "../styles/profileDetails.module.css";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { CaretRightOutlined, CloudDownloadOutlined, DeleteOutlined, ExclamationCircleOutlined, FileOutlined, FolderOutlined, HddOutlined, LinkOutlined, MoreOutlined, PlusCircleFilled, PlusCircleOutlined, RobotOutlined, UserOutlined, } from "@ant-design/icons";
import MLSModal from "./MLSModal";
import UserDetailsModal from "./UserDetailsModal";
import { generateDataForShowclientOnTop } from "../../Common/utils/extraFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PropertyHandlers } from "../state/actions";
import { SignersModal } from "./SignersModal";
import { accountHandle } from "../../Account/state/actions";
import { checkIfDisabled, combineAgentWithComma, disabledTransactionText, getRequiredKeys, isSellingNotExecutedFunc } from "../../Common/commondata/commonData";
import { useMediaQuery } from "react-responsive";
import PanelComp from "./PanelComp";
import PropertyNavbar from "./PropertyNavbar";
import { OfferImportModal } from "./OfferImportModal";
import { formatPrice } from "../../DocumentSection/utils/helper";
import { PropertyDocsModal } from "./PropertyDocsModal";
import { PropertyImageModal } from "./PropertyImageModal";
import DisclosureDocCreate from "./DisclosureDocCreate";
import { TitleCompanyDetails } from "../../Rtd/component/TitleCompanyDetails";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { ClientPortaModal } from "../../Rtd/component/ClientPortaModal";




const ProfileDetails = ({ item, section, filterSort, setSelectedPropertyId, selectedPropertyId, selectedTransaction, readOnly }) => {
  const delegate = (section === "DELEGATE");
  const bos = (section === "BOS");
  const limited =  ((section === "LIMITED_TRANSACTION") || (section === "HOME"));
  const delegateAndLimited = (section === "DELEGATE") || (section === "LIMITED_TRANSACTION") || (section === "HOME");
  const home = (section === "HOME");
  const delegateSide = delegate && ((item?.isProperty) ? "SELLER" : "BUYER")
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const isMobile = useMediaQuery({ maxWidth: 803 });
  const { Panel } = Collapse;
  
  const agentDetails =  item?.currentAgentId ;
  const [activeKey, setActiveKey] = useState(undefined);
  const [showmodal, setshowModal] = useState(false);
  const [isMLSVisible, setIsMLSVisible] = useState({
    addModal: false,
    editModal: false,
    defaultAddress: item?.addressDetails
  });
  const [isModalOpen, setIsModalOpen] = useState({
    offerImport: false,
    propertyDocs: false,
    propertyImage: false,
    disclosureCreate: false
  });
  const [expand, setExpand] = useState({
    showMore: false,
    showLess: true
  });
  const [showcompanymodal, setShowcompanymodal] = useState(false);
  const [companyModalStep, setCompanyModalStep] = useState({
      step: 0,
      inBuilt: true,
      selectedBy: (item?.isProperty) ? "SELLER_AGENT" : "BUYER_AGENT",
      titleCompany: "",
      titleOffice: "",
      titleCloser: "",
      salesRep: ""
    });

  const [state, setState] = useState({
        isUseDetailModal: false,
        isSignersModal: false,
        });

  useEffect(()=>{
    if(item.isProperty && item.propertyId){
      if(item.propertyId === selectedPropertyId){
        handleMls();
      }
    }
  }, [])

  //   method call for OMD
  const offerTableHandleDocument = (record) => {
    let buildData = {
      builtForId: agentDetails?._id,
      key: agentDetails?._id,
      builtForSection: "OFFER_TABLE",
      propertyId: record?.propertyId,
      propertyImage: record?.images[0]?.imageUrl,
      fullAddress: record?.address,
      token: localStorage.getItem("userAuth"),
      ...((delegate) ? {delegateOwnerId: agentDetails?._id} : {}),
      ...((bos) ? {delegateOwnerId: agentDetails?._id, screenType: "BOS"} : {})
    };
    dispatch(PropertyHandlers.offerTableUrlShorthandApiCalling(buildData, location?.pathname));
  };

  const redirectOfferTable = (e) => {
    e.stopPropagation();
    if(item?.allOffers?.length > 0){
      offerTableHandleDocument(item)
    }
    else message.warning("No Offers")
  }

  const handleAccessAccount = (e, item) => {
    e.stopPropagation();
    // confirm({
    //   title: `Are you sure you want to go to the account of ${item?.currentAgentId?.fullName?`,
    //   content: "Note: You will be logged out from your current account",
    //   okText: "Yes",
    //   cancelText: "No",
    //   icon: <ExclamationCircleOutlined />,
    //   onOk() {
        dispatch(accountHandle.updateAccessProfile({delegateOwnerId: agentDetails._id, ...(bos && {screenType: "BOS"})}, true));
    //   },
    //   onCancel() {},
    // });
  };

  const profileInfo = ({ item, type }) => {
    const sellerAgentDetails = item?.currentAgentId; 
    if(delegate || bos){
      if(item?.isProperty){
        if(type === "IMAGE") return sellerAgentDetails?.profileImg?.original
        else if(type === "IMAGE_TEXT") return (sellerAgentDetails?.firstName?.charAt(0)?.toUpperCase() || "") + " " + (sellerAgentDetails?.lastName?.charAt(0)?.toUpperCase() || "")
        else if(type === "BROKER_NAME") return sellerAgentDetails?.fullName
        else if(type === "BROKER_BROKERAGE") return   sellerAgentDetails?.brokerageData && sellerAgentDetails?.brokerageData?.name

      }
      else {
        const buyerAgentDetails = item?.currentAgentId; 
        if(type === "IMAGE") return buyerAgentDetails?.profileImg?.original
        else if(type === "IMAGE_TEXT") return (buyerAgentDetails?.firstName?.charAt(0)?.toUpperCase() || "") + " " + (buyerAgentDetails?.lastName?.charAt(0)?.toUpperCase() || "")
        else if(type === "BROKER_NAME") return buyerAgentDetails?.fullName
        else if(type === "BROKER_BROKERAGE") return buyerAgentDetails?.brokerageData && buyerAgentDetails?.brokerageData?.name

      }
    }
    else{
      if(item?.isProperty){
        if(type === "IMAGE"){
          if(item?.sellerIds?.[0]?.isCorp) return item?.sellerIds?.[0]?.signers?.[0]?.personId?.profileImg?.original
          else return item?.sellerIds?.[0]?.personId?.profileImg?.original
        }
        else if(type === "IMAGE_TEXT"){
          if(item?.sellerIds?.[0]?.isCorp) return (item?.sellerIds?.[0]?.signers?.[0]?.personId?.firstName?.charAt(0)?.toUpperCase() || "") + (item?.sellerIds?.[0]?.signers?.[0]?.personId?.lastName?.charAt(0)?.toUpperCase() || "")
          else return (item?.sellerIds?.[0]?.personId?.firstName?.charAt(0)?.toUpperCase() || "") + (item?.sellerIds?.[0]?.personId?.lastName?.charAt(0)?.toUpperCase() || "")
        }
      }
      else{
        if(type === "IMAGE"){
          if(item?.buyerIds?.[0]?.isCorp) return item?.buyerIds?.[0]?.signers?.[0]?.personId?.profileImg?.original
          else return item?.buyerIds?.[0]?.personId?.profileImg?.original
        }
        else if(type === "IMAGE_TEXT"){
          if(item?.buyerIds?.[0]?.isCorp) return (item?.buyerIds?.[0]?.signers?.[0]?.personId?.firstName?.charAt(0)?.toUpperCase() || "") + (item?.buyerIds?.[0]?.signers?.[0]?.personId?.lastName?.charAt(0)?.toUpperCase() || "")
          else return (item?.buyerIds?.[0]?.personId?.firstName?.charAt(0)?.toUpperCase() || "") + (item?.buyerIds?.[0]?.personId?.lastName?.charAt(0)?.toUpperCase() || "")
        }
      }
    }
  }

  const propertyImages = (ele) => {
    if(ele?.propertyType?.includes("PRIVATE")){
      return (<Tooltip placement="top" title="RE-Sure"><img style={{width: "29px", borderRadius: "2px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/65b8f71bdff9fe6ba44c8501/MEMORIES/16RE-Sure%20Blue%20Bug.png" alt="RE-Sure"/></Tooltip>)
    }
    else if(ele?.propertyType?.some(ele => ele.includes("RECOLORADO"))){
      return (<Tooltip placement="top" title="REcolorado"><img style={{width: "31px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/64d5ce64dff9fe6ba4cfaf06/MEMORIES/18pastedImage82704" alt="REcolorado"/></Tooltip>)
    }
    else if(ele?.propertyType?.some(ele => ele.includes("IRES"))){
      return (<Tooltip placement="top" title="IRES"><img style={{width: "77px", height: "24px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/64d5ce64dff9fe6ba4cfaf06/MEMORIES/18pastedImage84057" alt="IRES"/></Tooltip>)
    }
    else if(ele?.propertyType?.some(ele => ele.includes("PPAR"))){
      return (<Tooltip placement="top" title="PPAR"><img style={{width: "73px", height: "24px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/dev/657ff2157e660a0701cfaa24/MEMORIES/19PPMLS-logo-MAIN-WebRGB.jpeg" alt="PPAR"/></Tooltip>);
    }
    else if(ele?.propertyType?.some(ele => ele.includes("PAR"))){
      return (<Tooltip placement="top" title="PAR"><img style={{width: "68px", height: "24px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/qa/6444b9c521382a6780572f63/MEMORIES/2pastedImage68271" alt="PAR"/></Tooltip>);
    }
    else if(ele?.propertyType?.some(ele => ele.includes("GJARA"))){
      return (<Tooltip placement="top" title="GJARA"><img style={{width: "77px", height: "27px", cursor: "pointer"}} src="https://resureprojectbucket.s3.us-east-2.amazonaws.com/prod/64cb4128b00a232d9c2cc0d4/MEMORIES/29gjara-logo.png" alt="GJARA"/></Tooltip>);
    }
    else return "";
  }

  const showMLSModal = (e) => {
    e.stopPropagation();
    handleMls();
    setSelectedPropertyId(item.propertyId);
  }

  const handleMls = (isClose) => {
    if(item?.linkedPropertyIds?.length){
      setIsMLSVisible({
        ...isMLSVisible,
        editModal: true
      })
    }
    else{
      setIsMLSVisible({
        ...isMLSVisible,
        addModal: isClose ? false : true
      })
    }
  }

  const handleMLSCancel = () => {
    setSelectedPropertyId(null);
    setIsMLSVisible({
      ...isMLSVisible,
      editModal: false,
      addModal: false
    })
  }

  const handleLinkMoreMls = (item) => {
    setIsMLSVisible({
      ...isMLSVisible,
      editModal: false,
      addModal: true
    })
  }

  const getPrimaryContact = (item) => {
    if(item?.isProperty || item?.isErts){
      if(item?.sellerIds?.[0]?.isCorp) return item?.sellerIds?.[0]?.signers?.[0]?.personId?._id
      else return item?.sellerIds?.[0]?.personId?._id
    } else {
      if(item?.buyerIds?.[0]?.isCorp) return item?.buyerIds?.[0]?.signers?.[0]?.personId?._id
      else return item?.buyerIds?.[0]?.personId?._id
    }
  }

  const handleImageClick = (item) => {
    let {redirect, stateObj}=  generateDataForShowclientOnTop((item?.isProperty) ? item?.sellerIds : item?.buyerIds);
    if(bos){
      history.push({
        pathname: `/contacts`,
        state: {
          clientId: item?.currentAgentId?._id
        },
      });
      return;
    }
    const primaryContact = getPrimaryContact(item);
    if (redirect) {
      dispatch(PropertyHandlers.getIfContactIsDeletedOrArchived(primaryContact, history, stateObj))
    //   history.push(stateObj);
    } else {
      return;
    }
  };

  const handleCheck = () => {
    if(item.isOffer){
      if(selectedTransaction?.buying?.includes(item.offerId)){
        return true
      }
      return false;
    }
    else if(item.isProperty){
      if(selectedTransaction?.sellingProperty?.includes(item.propertyId)){
        return true;
      }
      return false;
    }
    return false;
  };

  const transactionStatus = (item?.isProperty) ? item?.propertyStatus : item?.actualOfferStatus;
  const actualTransactionStatus = (item?.isProperty) ? item?.actualPropertyStatus : item?.status;

  const checkForDisable = checkIfDisabled({openFor: (item?.isProperty) ? "SELLER" : "BUYER", actualPropertyStatus: item?.actualPropertyStatus, buyingStatus: item?.actualOfferStatus, offerStatus: item?.status});

  const displayBuyersAndSellers = () => {
    return <div style={{display: "flex"}}>
    {
      (item?.isProperty) ? item?.sellerIds?.length > 0 ?
        <div style={{display: "inline-block"}} className={!limited && styles.hoverClients} {...((!limited) ? {onClick: (e) => { e.stopPropagation(); setState({...state, isSignersModal: true})}} : {})}>
          <div className={styles.singleTextWraping}>
            Sellers: {
              item?.sellerIds?.map((el, index, array) => (
                <>
                  {!el?.isCorp ? (
                    <span key={index}>
                        {el?.fullName}
                        {index === array.length - 1 ? "" : ", "}
                    </span>
                    ) : (
                    <span>
                        {el?.fullName}
                        {el?.signers && el?.signers.length > 0 && (
                        <span>
                            {" ("}
                            {el?.signers.map((ele, ind, arr) => (
                            <span key={ind}>
                                {ele?.fullName}
                                {ind === arr.length - 1 ? "" : ", "}
                            </span>
                            ))}
                            {")"}
                            {index === array.length - 1 ? "" : ", "}
                        </span>
                        )}
                    </span>
                  )}
                </>
              ))
            }
          </div>
        </div>
      :
      (<div style={{display: "inline-block"}} {...((!limited) ? {onClick: (e)=> {e.stopPropagation(); setState({...state,isUseDetailModal:true})}} : {})}
          className={`${styles.addSellers} ${(!limited) &&  styles.hoverClients}`}
        >
          Add Sellers To Listing
      </div>) :
          (item?.buyerIds?.length > 0) ?
            <div style={{ display: "inline-block" }} className={!limited && styles.hoverClients} {...((!limited) ? { onClick: (e) => { e.stopPropagation(); setState({ ...state, isSignersModal: true }) } } : {})}>
              <div className={styles.singleTextWraping}>
                Buyers: {
                  item?.buyerIds?.map((el, index, array) => (
                    <>
                      {!el?.isCorp ? (
                        <span key={index}>
                          {el?.fullName}
                          {index === array.length - 1 ? "" : ", "}
                        </span>
                      ) : (
                        <span>
                          {el?.fullName}
                          {el?.signers && el?.signers.length > 0 && (
                            <span>
                              {" ("}
                              {el?.signers.map((ele, ind, arr) => (
                                <span key={ind}>
                                  {ele?.fullName}
                                  {ind === arr.length - 1 ? "" : ", "}
                                </span>
                              ))}
                              {")"}
                              {index === array.length - 1 ? "" : ", "}
                            </span>
                          )}
                        </span>
                      )}
                    </>
                  ))
                }
              </div>
            </div> :
            transactionStatus === "DRAFT" ? 
            <div style={{ display: "inline-block" }} {...((!limited) ? { onClick: (e) => { e.stopPropagation(); setState({ ...state, isUseDetailModal: true }) } } : {})}
              className={`${styles.addSellers} ${(!limited) && styles.hoverClients}`}
            >
              Add Buyers To Offer
            </div>
            :
            <></>
      }
  </div>
  }

  const handleChange = (key) => {
    setActiveKey(key);
  };
  
  const isSellingNotExecuted = isSellingNotExecutedFunc({item});
  
  let propertyArrayKeys = ["isProperty", "images", "propertyYearBuilt", "address", "addressDetails", "listingId", "currentAgentId"]
  const propertyData = item.isSellingMatrix ? getRequiredKeys({filteredKeyArray: propertyArrayKeys, dataObject: item}) : {};
  const hanldeClickOfferImport = () => {
    setIsModalOpen({ ...isModalOpen,  offerImport: true });
  };

  const handlePropertyDocClick = () => {
    setIsModalOpen({ ...isModalOpen, propertyDocs: true });
  }

  const handleTitleCompany = (e) => {
    setCompanyModalStep({
        step: 0,
        inBuilt: true,
        selectedBy: item?.isProperty ? "SELLER_AGENT" : "BUYER_AGENT",
        titleCompany: "",
        titleOffice: "",
        titleCloser: "",
        salesRep: ""
    })
    setShowcompanymodal(true);
  }

  const handlePropertyImageCancel = () => {
    setIsModalOpen({ ...isModalOpen, propertyImage: false });
  }

  const handlePropertyImageClick = () => {
    setIsModalOpen({ ...isModalOpen, propertyImage: true });
  }

  const handleDisclosureCreateCancel = () => {
    setIsModalOpen({ ...isModalOpen, disclosureCreate: false });
  }

  const handleDisclosureCreateClick = () => {
    setIsModalOpen({ ...isModalOpen, disclosureCreate: true });
  }

  const successFunc = () => {
    const state = {
      category: ( (item?.isProperty) ? "SELLER" : "BUYER" ),
      categoryId: ( item?.isProperty ? item.propertyId : item?.offerId )
    }
    history.push({
      pathname: location?.pathname,
      state
    })
  }
  const handeldeleteTitleCompanydata = (e) => {
    const { confirm } = Modal;
    confirm({
      title: `Are you sure, you want to clear Title Company data?`,
      content: "",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
          dispatch(transactionLaneDataHandle.deleteTitleCompanyData({ propertyId: item?.propertyId, delegateSide, delegateOwnerId: (delegateSide || bos) && item?.currentAgentId?._id, successFunc }))
      },
      onCancel() { },
    });
  }

  const isWeb = true;

  const isSellingCard = !item.isSellingMatrix && item.isProperty;
  const handleExpand = ({showMore, showLess}) => {
    setExpand({
      showMore,
      showLess
    })
  }

  // Client Portal modal
  const handledataClick = () => {
    setshowModal(true);
    dispatch(PropertyHandlers.resetPropertyDocs());
  };

  const MenuItemOverlay = () => {
              <Tooltip title="Edit Title Company"><PlusCircleFilled style={{ color: "#085191", fontSize: "19px" }} /></Tooltip>
    return <Menu size="large">
      <Menu.Item
        {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: handeldeleteTitleCompanydata })}
        key="deleteTitle"
      >
        <DeleteOutlined
          style={{
            fontSize: 16,
            color: "#085191"
          }}
        />
        {" "}<span style={{ color: "04396B" }}>Clear Title Company</span>
      </Menu.Item>
      <Menu.Item
        {...(checkForDisable?.disabled ? {onClick: disabledTransactionText} : {onClick: handleTitleCompany})}
        key="deleteTitle"
      >
        <PlusCircleFilled
          style={{
            fontSize: 16,
            color: "#085191"
          }}
        />
        {" "}<span style={{ color: "04396B" }}>Edit Title Company</span>
      </Menu.Item>
    </Menu>
  }

  const clientNullCheck = ({clientIds}) => {
    for(let ele of clientIds){
      if(ele?.isCorp){
        for(let signer of ele?.signers){
          if(!signer?.personId){
            return true;
          }
        }
      }
      else{
        if(!ele?.personId){
          return true;
        }
      }
    }
    return false
  }

  return (
    <>
      <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
        {
          (!(readOnly?.value || readOnly?.home)) && (limited && <Checkbox
            checked={ handleCheck() }
          />)
        }
        <div style={{width: "100%"}}>
          <div onClick={(e)=>e.stopPropagation()}>
            {
              (isMLSVisible.addModal || isMLSVisible.editModal) && <MLSModal handleLinkMoreMls={handleLinkMoreMls} isMLSVisible={isMLSVisible} filterSort={filterSort} selectedData={item} handleMLSCancel={handleMLSCancel} handleMls={handleMls} section={section}/>
            }
            {state.isUseDetailModal && <UserDetailsModal item={item} state={state} section={section} filterSort={filterSort} setState={setState}  delegateOwnerId={(delegate || bos) && agentDetails?._id}/>}
            {state.isSignersModal && <SignersModal item={item} state={state} setState={setState} transactionStatus={transactionStatus} />}
            {isModalOpen.propertyImage && <PropertyImageModal item={item} handlePropertyImageCancel={handlePropertyImageCancel} />}
            {isModalOpen.disclosureCreate && <Modal
                open={true}
                footer={false}
                onCancel={handleDisclosureCreateCancel}
                width={700}
                title={
                <div style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px", height: "0px" }}>Create Disclosure Documents</div>
                }
                style={{ maxHeight: "80%", marginTop:"-80px" }}
              >
                <div style={{display: "flex", justifyContent: "center", padding: "10% 20px"}}>
                  <DisclosureDocCreate item={item}/>
                </div>
              </Modal>
            }
            {isModalOpen?.propertyDocs && (
              <PropertyDocsModal
                isModalOpen={isModalOpen}
                section={section}
                setIsModalOpen={setIsModalOpen}
                role={(item?.isProperty) ? "SELLER" : "BUYER"}
                item={item}
                isWeb={isWeb}
              />
            )}
            {isModalOpen?.offerImport && (
              <OfferImportModal
                isModalOpen={isModalOpen}
                section={section}
                setIsModalOpen={setIsModalOpen}
                selectedData={item}
              />
            )}
            {showmodal && !isModalOpen.isEmailPresent &&
              <ClientPortaModal
                personId={item?.currentAgentId?._id}
                showmodal={showmodal}
                Role={(item?.isOffer) ? "BUYER" : "SELLER"}
                offerid={item?.offerId}
                propertyId={item?.propertyId }
                delegateSide={delegate && ((item?.isOffer) ? "BUYER" : "SELLER")}
                delegateOwnerId = {agentDetails?._id}
                setIsModalOpen={setIsModalOpen}
                clientNullCheck={clientNullCheck}
                isModalOpen={isModalOpen}
                filterSort={filterSort}
                selectedData={item}
                setShowModal={ setshowModal}
              />
            }
          </div>
          <div className={home ? styles.homeProfileBox : styles.profileBox}>
            {/* profile img div  */}
            <div className={home ? styles.homeProfileImgBox : styles.profileImgBox}>
              <div>
                {profileInfo({item, type: "IMAGE"}) ? (
                  <Avatar {...((!delegateAndLimited) ? {onClick: ()=>handleImageClick(item)} : {})}
                    style={{ border: "1px solid grey" }}
                    className={!delegateAndLimited && styles.profileImg}
                    size={60}
                    src={profileInfo({item, type: "IMAGE"})}
                  />
                ) : (
                  <Avatar {...((!delegateAndLimited) ? {onClick: ()=>handleImageClick(item)} : {})} size={60} style={{ background: "#085191", fontSize: "20px" }} className={(profileInfo({item, type: "IMAGE_TEXT"}) && !delegateAndLimited) && styles.profileImg2}>
                    {profileInfo({item, type: "IMAGE_TEXT"}) && profileInfo({item, type: "IMAGE_TEXT"}) !== "undefined" ?
                    profileInfo({item, type: "IMAGE_TEXT"}) :
                    <UserOutlined style={{fontSize:"25px",}} />}
                  </Avatar>
                )}
              </div>
              {/* name broker property detail div  */}
              <div className={home ? styles.homeBrokerDetails : styles.brokerDetails}>
                {
                  (delegate || bos)  ?
                  <div className={styles.singleTextWraping}>
                    <Typography.Text ellipsis style={{ flex: '1 1 auto', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: (item?.currentAgentId?.brokerageData && item?.currentAgentId?.brokerageData?.name && !isMobile) ? "70%" : "" }}>
                      Agent: {profileInfo({ item, type: "BROKER_NAME" })} {profileInfo({ item, type: "BROKER_BROKERAGE" }) && ` - ${profileInfo({ item, type: "BROKER_BROKERAGE" })}`}
                    </Typography.Text>
                    <button
                      style={{ flex: '0 0 auto', marginLeft: '10px', padding: '4px', lineHeight: '13px', cursor: 'pointer', fontSize: '15px' }}
                      className={`${(!limited) && styles.hoverClients}`}
                      onClick={(e) => handleAccessAccount(e, item)}
                    >
                      Access Account
                    </button>
                  </div>
                  : 
                  displayBuyersAndSellers()
                }
                {
                  item?.isMatrix ? <div style={{marginTop: "5px"}}>
                    <PropertyNavbar section={section} item={item}/>
                  </div> : ""
                }
                {(item?.isMatrix || item?.matrixId) ? "" : <div className={styles.singleTextWraping}>{item?.address}</div>}
                {
                  (delegate || bos)  && displayBuyersAndSellers()
                }
                {item?.isMatrix ? "" : <div style={{display: "flex", gap: "10px", alignItems: "center", color: "rgb(96, 96, 96)", padding: "4px 0px"}}>
                  {
                    (item?.linkedPropertyIds?.length) ? item?.linkedPropertyIds?.map((ele)=>{
                      return propertyImages(ele?.propertyId)
                    }) : propertyImages(item)
                  }
                  {!limited && <div style={{display: "flex", gap: "25px", alignItems: "center"}}>
                    <div className={styles.linkMls} style={{lineHeight: "21px"}}>
                        {((item?.isProperty && isSellingNotExecuted) && item?.propertyType?.includes("PRIVATE")) &&
                          <Tooltip title="Link To MLS">
                            <LinkOutlined style={{fontSize:"20px"}} {...(checkForDisable?.disabled ? {onClick: (e)=>{ e.stopPropagation();disabledTransactionText();}} : {onClick: showMLSModal})}/>
                          </Tooltip>
                        }
                    </div>
                    {item?.isProperty && <div style={{lineHeight: "11px"}}>
                      <Tooltip title="Property Image">
                        <BiImageAdd
                          onClick={handlePropertyImageClick}
                          className={styles.hoverClients}
                          style={{
                              color: "#2C59A9",
                              fontSize: "25px",
                          }}
                        />
                      </Tooltip>
                    </div>}
                    {(item?.isSellingMatrix) && <div className={styles.secondDetailList} {...(checkForDisable?.disabled ? {onClick: disabledTransactionText} : {onClick: handlePropertyDocClick})}>
                      <FolderOutlined />
                      <span>Listing Docs</span>
                    </div>}
                    {(item?.isSellingMatrix && isSellingNotExecuted) && <div>
                      <Tooltip placement="top" title={"Import offer from PDF document"}>
                        <div className={styles.secondDetailList} {...(checkForDisable?.disabled ? {onClick: disabledTransactionText} : {onClick: hanldeClickOfferImport})}>
                          <CloudDownloadOutlined />
                          <span>Offer Import</span>
                        </div>
                      </Tooltip>
                    </div>}
                    {
                      item?.isSellingMatrix && <div className={styles.secondDetailList} onClick={handledataClick}>
                        <RobotOutlined />
                        <span>Client Portal</span>
                      </div>
                    }
                  </div>}
                </div>}
              </div>
            </div>

            {/* status & dates div  */}
            <div className={home ? styles.homeStatusBox : styles.statusBox}>
            <div>
                <div>
                  {
                    item?.isMatrix ? <div>
                      <div style={{display: "flex", gap: "3px", alignItems: "center", justifyContent: "end"}}>
                        <FileOutlined /> 
                        <span>ERTB</span>
                      </div>
                      <div>11/01/2024 - 05/01/2025</div>
                    </div> : (item?.matrixId) ? "" : <StatusLabel currentStatus={transactionStatus} actualStatus={actualTransactionStatus} item={item} filterSort={filterSort} limited={limited} section={section}/>
                  }
                </div>

                {(item?.isMatrix || item?.matrixId || item?.isSellingMatrix) ? "" : <div style={{marginTop: "4px",fontSize: home ? "0.8rem" : ""}}>
                  Updated:{" "}
                  {moment(item?.updatedAt).format(
                    "MM/DD/YYYY hh:mm a",
                  )}{" "}
                </div>}
                {
                  (item?.isSellingMatrix) && <div className={styles.secondDetailList} onClick={handleDisclosureCreateClick}>
                    <PlusCircleFilled
                      style={{
                        color: "#085191",
                      }}
                    />
                    <span>Disclosure Docs</span>
                  </div>
                }
                {item?.isMatrix ? "" : item?.closingDate && !isNaN(Date.parse(item?.closingDate)) && <div style={{fontSize: home ? "0.8rem" : ""}}>Closing: {moment(item?.closingDate).format("MM/DD/YYYY")}</div>}
              </div>
            </div>

            {/* OMD & side div  */}
            {!item?.matrixId && <div className={home ? styles.homeOfferDetailBox : styles.offerDetailBox}>
              <div
                className={(item?.isProperty) ? home ? styles.homeSellingCard : styles.sellingCard : home ? styles.homeBuyingCard : styles.buyingCard}
              >
                {item?.isSellingMatrix ? "Selling" : item?.isMatrix ? "Buying Matrix" : "Buying"}
                
              </div>

              {(item?.isSellingMatrix && isSellingNotExecuted) ? (
              <div
                className={`${home ? styles.homeOfferNumberCard : styles.offerNumberCard} ${(!limited) &&  styles.hoverClients}`}
                {...((!limited) ? {onClick: redirectOfferTable} : {})}
              >
                <div>{item?.allOffers?.length || 0}</div>
                <div>{(item?.allOffers?.length === 1) ? "Offer" : "Offers"}</div>
              </div>)
              : item?.isMatrix ? 
              <div
                className={`${home ? styles.homeOfferNumberCard : styles.offerNumberCard} ${(!limited) &&  styles.hoverClients}`}
                // {...((!limited) ? {onClick: redirectOfferTable} : {})}
              >
                <div>{item?.allOffers?.length || 0}</div>
                {/* <div>{(item?.allOffers === 1) ? "Offer" : "Offers"}</div> */}
              </div> : (<></>)}
            </div>}
          </div>
        </div>
      </div>
      {
        item?.isMatrix ? "" : item?.isSellingMatrix && <div>
          {
            showcompanymodal && 
            <TitleCompanyDetails
              section={section}
              setShowcompanymodal={setShowcompanymodal}
              showcompanymodal={showcompanymodal}
              selectedStatus={(item?.isProperty) ? "SELLER" : "BUYER"}
              companyModalStep={companyModalStep}
              setCompanyModalStep={setCompanyModalStep}
              item={item}
              type={"TRANSACTIONS"}
              successFunc={successFunc}
            />
          }
          {
            (Object.keys(item?.titleData || {}).length > 0) ? <div className={styles.titleCardFont}>
              <Dropdown overlay={<MenuItemOverlay />} trigger={["hover", "click"]}>
                <MoreOutlined className={styles.statusMenuIcon} style={{ fontWeight: "800", color: "blue", transform: "scale(1.2)" }} />
              </Dropdown>
              <span className={styles.singleTextWraping}>{item?.titleData?.titleCompanyLogo ? <img style={{minWidth: "29px", minHeight: "24px", objectFit: "contain", maxWidth: "15%", maxHeight:"30px", borderRadius: "2px"}} src={item?.titleData?.titleCompanyLogo} alt="Logo"/> : <HddOutlined style={{ fontSize: "19px" }}/>} {item?.titleData?.titleCompanyName}, {item?.titleData?.titleOfficeName}</span>
            </div> : <div className={styles.titleCardFont} {...(checkForDisable?.disabled ? {onClick: disabledTransactionText} : {onClick: handleTitleCompany})}>
              <PlusCircleFilled style={{ color: "#085191", fontSize: "19px" }} />
              <span>Add Title company</span>
            </div>
          }
        </div>
      }
      {
        (item?.isMatrix) && <div style={{textTransform: "capitalize", fontSize: "16px"}}>
          <div className={`${styles.buyingMatrixBox} ${styles.buyingMatrixHeading}`}>
            {
              ["Offers", "Updated", "Status"]?.map((ele)=>{
                return <div style={{textAlign: "center"}}>{ele}</div>
              })
            }
          </div>
          {
            <Collapse
              accordion
              // ghost
              expandIcon={
                ({ isActive }) =>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              }
              onChange={handleChange}
              activeKey={activeKey}
            >
              {(item?.allOffers)?.map((element, idx)=>{
                return <Panel
                  className={`${styles.panelMatrixBox}`}
                  style={{
                    width:"100%",
                    margin:'auto',
                    borderRadius:"10px",
                    background: (((activeKey == idx) && !limited) ? '#E7F5E4' : "#FFFFFF"),
                  }}
                  header={<div className={`${styles.buyingMatrixContentBox} ${styles.buyingMatrixContent}`}>
                    <div className={styles.singleTextWraping}>{element?.address}</div>
                    <div style={{textAlign: "center"}}>{moment(element?.updatedAt).format("MM/DD/YYYY hh:mm a")}</div>
                    <div style={{display: "flex", justifyContent: 'center'}}>
                      <StatusLabel currentStatus={transactionStatus} actualStatus={actualTransactionStatus} item={element} filterSort={filterSort} limited={limited} section={section}/>
                    </div>
                  </div>}
                  key={idx}
                >
                  { !limited && <div style={{padding: "15px 5px",background: (((activeKey == idx) && !limited) ? '#E7F5E4' : "#FFFFFF"),}}>
                    <ProfileDetails filterSort={filterSort} readOnly={readOnly} item={element} section={section} setSelectedPropertyId={setSelectedPropertyId} selectedTransaction={selectedTransaction} selectedPropertyId={selectedPropertyId}/>
                    <PanelComp item={element} section={section} filterSort={filterSort}/>
                  </div> }
                </Panel>
              })}
            </Collapse>
          }
        </div>
      }
      {
        (item?.isSellingMatrix && (item?.allOffers?.length > 0)) && <div style={{textTransform: "capitalize", fontSize: "16px"}}>
          <div className={`${styles.sellingMatrixBox} ${styles.buyingMatrixHeading}`}>
            {
              ["Agents", "Price", "Date Submitted", "Updated", "Status"]?.map((ele)=>{
                return <div style={{textAlign: "center"}}>{ele}</div>
              })
            }
          </div>
          {
            <Collapse
              accordion
              // ghost
              expandIcon={
                ({ isActive }) =>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              }
              onChange={handleChange}
              activeKey={activeKey}
            >
              {(item?.allOffers)?.map((element, idx)=>{
                if(item?.acceptedOfferExists){
                  if(expand?.showMore){
                    
                  }
                  else if(expand?.showLess && idx > 0){
                    return;
                  }
                }
                element = {...element, ...propertyData, ...element.offersData, isOfferAccepted: (item?.previousStatus === "ACCEPTED" || item?.propertyStatus === "ACCEPTED")};
                const actualTransactionStatus = element?.status;
                const transactionStatus = element?.actualOfferStatus;
                delete element.isSellingMatrix;
                return <Panel
                  className={`${styles.panelMatrixBox}`}
                  style={{
                    width:"100%",
                    margin:'auto',
                    borderRadius:"10px",
                    background: (((activeKey == idx) && !limited) ? '#E7F5E4' : "#FFFFFF"),
                  }}
                  header={<div className={`${styles.sellingMatrixContentBox} ${styles.buyingMatrixContent}`}>
                    <div className={styles.singleTextWraping}>{combineAgentWithComma({ agents: element?.newTransactionData?.BuyerAgents })}</div>
                    <div style={{textAlign: "center"}} className={styles.singleTextWraping}>{formatPrice({ price: element?.newTransactionData?.PurchasePrice, source: "TRANSACTIONS" })}</div>
                    <div style={{textAlign: "center"}} className={styles.singleTextWraping}>{moment(element?.dateSubmitted).format("MM/DD/YYYY hh:mm a")}</div>
                    <div style={{textAlign: "center"}} className={styles.singleTextWraping}>{moment(element?.updatedAt).format("MM/DD/YYYY hh:mm a")}</div>
                    <div style={{display: "flex", justifyContent: 'center'}}>
                      <StatusLabel currentStatus={transactionStatus} actualStatus={actualTransactionStatus} item={element} filterSort={filterSort} limited={limited} section={section} removeAction={true}/>
                    </div>
                  </div>}
                  key={idx}
                >
                  { !limited && <div style={{padding: "15px 5px",background: (((activeKey == idx) && !limited) ? '#E7F5E4' : "#FFFFFF"),}}>
                    <PanelComp item={element} section={section} filterSort={filterSort} onlyOptions={true}/>
                  </div> }
                </Panel>
              })}
              {(item?.acceptedOfferExists && (item?.allOffers?.length > 1)) && (expand?.showMore ? <div className={styles.expandText} onClick={()=>handleExpand({showMore: false, showLess: true})}>Show Less</div> : expand?.showLess ? <div className={styles.expandText} onClick={()=>handleExpand({showMore: true, showLess: false})}>Show All Offers</div> : "")}
            </Collapse>
          }
        </div>
      }
    </>
  );
};

export default ProfileDetails;
